import axios from 'axios'

function getRequest(options){
  return new Promise((resolve,reject)=>{
    axios.get(options.path, {
      params:options.params
    }).then(res=>{
      if(res.data.head.errCode === "0000"){
        resolve(res.data)
      } else {
        reject()
      }
    })
  })
}

function postRequest(options){
  return new Promise((resolve,reject)=>{
    axios.post(options.path, options.params, {
      headers: options.headers
    }).then(res=>{
      if(res.data.head.errCode === "0000"){
        resolve(res.data)
      } else {
        reject()
      }
    })
  })
}

export {getRequest, postRequest}



// WEBPACK FOOTER //
// ./src/service/axios.js